import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpOrderTableComponent} from './dcp-order-table/dcp-order-table.component';
import {DcpBundleOrderTableComponent} from './dcp-bundle-order-table/dcp-bundle-order-table.component';
import {CheckoutLicensesModule} from '../checkout-licenses/checkout-licenses.module';
import {TermsAndConditionsModule} from '../checkout-terms-conditions/terms-and-conditions.module';

import {I18nModule} from '@spartacus/core';

@NgModule({
  imports: [
    CommonModule,
    CheckoutLicensesModule,
    TermsAndConditionsModule,
    I18nModule,
    DcpOrderTableComponent,
    DcpBundleOrderTableComponent,
  ],
  exports: [DcpOrderTableComponent, DcpBundleOrderTableComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrderTableModule {}
